import { render, staticRenderFns } from "./SettlementTransactionExportsModal.vue?vue&type=template&id=5368bd9a&scoped=true"
import script from "./SettlementTransactionExportsModal.vue?vue&type=script&lang=js"
export * from "./SettlementTransactionExportsModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementTransactionExportsModal.vue?vue&type=style&index=0&id=5368bd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368bd9a",
  null
  
)

export default component.exports